export default __webpack_public_path__ + "static/media/rug7-min.76858361.jpg";